/* eslint-disable react/prop-types */

import React from "react";
import { Fade } from "react-awesome-reveal";

const Service = ({ data }) => (
  <div className="bg-white">
    <div className="container mx-auto px-4 pb-28 pt-20">
      <Fade direction="up" triggerOnce>
        <p className="mb-2 text-center text-sm font-semibold uppercase tracking-widest text-gold-700">
          What We Make
        </p>
        <h2 className="font-display text-center text-4xl text-maroon-900 sm:text-5xl">
          Our Product Categories
        </h2>
        <p className="mx-auto mb-12 mt-3 max-w-xl text-center text-lg font-light text-slate-500">
          Explore our wide range of sauces and condiments.
        </p>
      </Fade>
      <div className="grid grid-cols-1 gap-6 px-2 sm:grid-cols-3 sm:gap-8 xl:gap-10">
        {data.map((item, index) => (
          <Fade direction={item.animation} delay={150 * index} key={item.title} triggerOnce>
            <div className="group overflow-hidden rounded-2xl border border-slate-100 bg-white shadow-md transition-all duration-300 hover:-translate-y-1 hover:shadow-xl">
              <div className="relative aspect-[4/3] overflow-hidden bg-slate-50">
                <img
                  src={item.imageUrl}
                  alt={item.title}
                  loading="lazy"
                  className="h-full w-full object-cover transition-opacity duration-500 group-hover:opacity-0"
                />
                <img
                  src={item.imageUrl2}
                  alt=""
                  loading="lazy"
                  className="absolute inset-0 h-full w-full object-cover opacity-0 transition-opacity duration-500 group-hover:opacity-100"
                />
              </div>
              <h3 className="py-6 text-center font-display text-xl font-semibold text-maroon-800">
                {item.title}
              </h3>
            </div>
          </Fade>
        ))}
      </div>
    </div>
  </div>
);

export default Service;
